<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <dashboard>
        </dashboard> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import dashboard from './todo-dashboard'
export default {
    components: {
        dashboard
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-dashboard/base-dashboard.vue